import { render, staticRenderFns } from "./LastLessonCard.vue?vue&type=template&id=25b6cb08&scoped=true&"
import script from "./LastLessonCard.vue?vue&type=script&lang=js&"
export * from "./LastLessonCard.vue?vue&type=script&lang=js&"
import style0 from "./LastLessonCard.vue?vue&type=style&index=0&id=25b6cb08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b6cb08",
  null
  
)

export default component.exports